export default IconBow => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bow" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M17 3h4v4" />
  <path d="M21 3l-15 15" />
  <path d="M3 18h3v3" />
  <path d="M16.5 20c1.576 -1.576 2.5 -4.095 2.5 -6.5c0 -4.81 -3.69 -8.5 -8.5 -8.5c-2.415 0 -4.922 .913 -6.5 2.5l12.5 12.5z" />
</svg>`;